// Kit selector — one variant update per change so the page does not blink.
document.addEventListener('DOMContentLoaded', function () {
  const kitTypeSelector = document.querySelector('[name="options[Tipo di KIT]"]');
  const boosterSelector = document.querySelector('[name="options[Boosters]"]');

  if (!kitTypeSelector || !boosterSelector) return;

  const variantSelects = kitTypeSelector.closest('variant-selects');
  const originalBoosterOptions = Array.from(boosterSelector.options).map((opt) => opt.cloneNode(true));
  const dashOption = originalBoosterOptions.find((opt) => opt.value.trim() === '-');
  const placeholderLabel = 'Seleziona il tuo Booster';

  function getVariantData() {
    if (!variantSelects) return [];
    const jsonEl = variantSelects.querySelector('[type="application/json"]');
    if (!jsonEl) return [];
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      return [];
    }
  }

  function variantMediaId(variant) {
    if (variant.featured_media && variant.featured_media.id != null) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id != null) return String(variant.featured_image.id);
    return '';
  }

  function findPricedVariant(kitType) {
    const variants = getVariantData();
    return (
      variants.find((variant) => variant.option1 === kitType && String(variant.option2 || '').trim() !== '-') ||
      variants.find((variant) => variant.option1 === kitType)
    );
  }

  function getSectionId() {
    return variantSelects ? variantSelects.dataset.section : null;
  }

  function getProductForm() {
    const sectionId = getSectionId();
    return sectionId ? document.getElementById(`product-form-${sectionId}`) : document.querySelector('form[action*="/cart/add"]');
  }

  function boosterStillRequired() {
    return kitTypeSelector.value !== 'Silver' && boosterSelector.value.trim() === '-';
  }

  function formatMoney(cents) {
    const amount = (Number(cents) / 100).toFixed(2);
    const sample = document.querySelector('.price-item');
    const sampleText = sample ? sample.textContent.trim() : '';
    if (sampleText.includes('€') && !sampleText.trim().startsWith('€')) {
      return amount.replace('.', ',') + ' €';
    }
    return '€' + amount;
  }

  function setAddButton(disabled, label) {
    const form = getProductForm();
    if (!form) return;

    const button = form.querySelector('[name="add"]');
    const labelEl = form.querySelector('[name="add"] > span');
    if (!button) return;

    if (disabled) {
      button.setAttribute('disabled', 'disabled');
      if (labelEl && label) labelEl.textContent = label;
      return;
    }

    button.removeAttribute('disabled');
    if (labelEl) {
      labelEl.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Aggiungi al carrello';
    }
  }

  function patchDisplayedPrice() {
    if (!boosterStillRequired()) return;

    const displayVariant = findPricedVariant(kitTypeSelector.value);
    const priceRoot = document.getElementById(`price-${getSectionId()}`);
    if (!displayVariant || !priceRoot) return;

    priceRoot.classList.remove('hidden');

    const salePrice = priceRoot.querySelector('.price-item--sale');
    const regularPrice = priceRoot.querySelector('.price-item--regular');
    const hasCompare =
      displayVariant.compare_at_price && displayVariant.compare_at_price > displayVariant.price;

    if (hasCompare) {
      priceRoot.classList.add('price--on-sale');
      if (regularPrice) regularPrice.textContent = formatMoney(displayVariant.compare_at_price);
      if (salePrice) salePrice.textContent = formatMoney(displayVariant.price);
      else if (regularPrice) regularPrice.textContent = formatMoney(displayVariant.price);
    } else {
      priceRoot.classList.remove('price--on-sale');
      if (regularPrice) regularPrice.textContent = formatMoney(displayVariant.price);
    }

    setAddButton(true, placeholderLabel);
  }

  function restorePlaceholderLabel() {
    const placeholder = boosterSelector.querySelector('option.placeholder-option');
    if (placeholder) placeholder.textContent = placeholderLabel;
  }

  function rebuildBoosterOptions() {
    const selectedKit = kitTypeSelector.value;
    boosterSelector.innerHTML = '';

    if (selectedKit === 'Silver') {
      if (dashOption) boosterSelector.appendChild(dashOption.cloneNode(true));
      boosterSelector.value = '-';
      return;
    }

    if (dashOption) {
      const placeholder = dashOption.cloneNode(true);
      placeholder.textContent = placeholderLabel;
      placeholder.value = '-';
      placeholder.classList.add('placeholder-option');
      boosterSelector.appendChild(placeholder);
    }

    originalBoosterOptions.forEach((opt) => {
      if (opt.value.trim() !== '-') boosterSelector.appendChild(opt.cloneNode(true));
    });

    boosterSelector.value = '-';
  }

  function emitVariantChange() {
    boosterSelector.dispatchEvent(new Event('change', { bubbles: true }));
    restorePlaceholderLabel();
  }

  function extractMediaId(value) {
    if (!value) return '';
    const parts = String(value).split('-');
    return parts[parts.length - 1] || '';
  }

  function selectVariantFromMedia(mediaId) {
    if (!mediaId) return false;

    const matches = getVariantData().filter((variant) => variantMediaId(variant) === String(mediaId));
    if (!matches.length) return false;

    const kitTypes = [...new Set(matches.map((variant) => variant.option1))];
    if (kitTypes.length !== 1) return false;

    const kitType = kitTypes[0];
    const boosters = [...new Set(matches.map((variant) => String(variant.option2 || '').trim()))];
    const uniqueRealBoosters = boosters.filter((booster) => booster && booster !== '-');

    if (kitTypeSelector.value !== kitType) {
      kitTypeSelector.value = kitType;
      rebuildBoosterOptions();
    }

    if (uniqueRealBoosters.length === 1) {
      boosterSelector.value = uniqueRealBoosters[0];
    }

    emitVariantChange();
    return true;
  }

  function bindGalleryClicks() {
    const sectionId = getSectionId();
    if (!sectionId) return;

    const variantMediaIds = new Set(getVariantData().map(variantMediaId).filter(Boolean));
    if (!variantMediaIds.size) return;

    document.querySelectorAll(`[id^="MediaGallery-${sectionId}"]`).forEach((gallery) => {
      gallery.querySelectorAll('[data-target], [data-media-id]').forEach((item) => {
        const mediaId = extractMediaId(item.dataset.target || item.dataset.mediaId);
        if (variantMediaIds.has(mediaId)) item.classList.add('kit-variant-media');
      });

      gallery.addEventListener('click', (event) => {
        const item = event.target.closest('[data-target], [data-media-id]');
        if (!item || !gallery.contains(item)) return;

        const mediaId = extractMediaId(item.dataset.target || item.dataset.mediaId);
        selectVariantFromMedia(mediaId);
      });
    });
  }

  kitTypeSelector.addEventListener(
    'change',
    function (event) {
      event.stopImmediatePropagation();
      rebuildBoosterOptions();
      emitVariantChange();
    },
    true
  );

  rebuildBoosterOptions();
  restorePlaceholderLabel();
  bindGalleryClicks();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, patchDisplayedPrice);
  }
});
